/** Filename suffix for exported CSV/Excel downloads. */
export function exportDownloadTimestamp(): string {
	const d = new Date();
	const iso = d.toISOString().split('T')[0];
	return `${iso}-${d.getHours()}${d.getMinutes()}`;
}
